export function SquareRootXIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_9_96)">
        <path
          d="M23.0625 3.23145C23.6077 3.23145 24.0496 3.67284 24.0498 4.21777C24.0498 4.76282 23.6079 5.20508 23.0625 5.20508H9.30176L6.92773 19.9385C6.8506 20.4172 6.43704 20.7686 5.95215 20.7686C5.57974 20.7685 5.24062 20.5589 5.07324 20.2314L5.0127 20.084L2.72656 12.9873H0.9375C0.392135 12.9873 0.0498047 12.5451 0.0498047 12C0.0498047 11.4549 0.392135 11.0127 0.9375 11.0127H3.44531C3.87389 11.0128 4.25326 11.2896 4.38477 11.6973L5.63086 15.5664L7.48535 4.06152L7.50391 3.97266C7.6147 3.54024 8.00583 3.23165 8.45996 3.23145H23.0625Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.1"
        />
        <path
          d="M19.3571 8.89172C19.745 8.57583 20.3169 8.59886 20.6784 8.96008L20.7458 9.03528C21.0411 9.39707 21.0411 9.9186 20.7458 10.2804L20.6784 10.3556L17.6266 13.4054L20.6784 16.4552L20.7458 16.5304C21.0411 16.8922 21.0411 17.4137 20.7458 17.7755L20.6784 17.8507C20.3168 18.2121 19.745 18.2343 19.3571 17.9181L19.2819 17.8507L16.2302 14.7999L13.1784 17.8507C12.8168 18.2121 12.245 18.2343 11.8571 17.9181L11.7819 17.8507C11.3963 17.4653 11.3963 16.8406 11.7819 16.4552L14.8327 13.4054L11.7819 10.3556C11.3963 9.97023 11.3964 9.34552 11.7819 8.96008L11.8571 8.89172C12.245 8.57583 12.8169 8.59886 13.1784 8.96008L16.2302 12.0099L19.2819 8.96008L19.3571 8.89172Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.1"
        />
      </g>
      <defs>
        <clipPath id="clip0_9_96">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
